
import { Header } from "./Header";


export const Overlay = ({ referrer }) => (
  <div className="left-box-overlay" id="main-map-overlay">
    <Header referrer={referrer} />
    <h2 className="chart-title" style={{fontWeight:"900", }}>
    How your NYC neighbors voted in 2024
    </h2>

    <p className="chart-dek ml-0">
    New York City had the lowest Democratic vote share in decades, and former President Donald Trump made <a style={{color:"#0c71fa"}} href="https://www.thecity.nyc/2024/11/05/election-day-voters-sheepshead-bay-chelsea/">significant gains</a> in the <a  style={{color:"#0c71fa"}} href="https://projects.thecity.nyc/the-city-election-coverage-2024/">2024 presidential election</a>. Here’s how the vote broke down in each election district. 
    </p>
    <div className="chart-dek" style={{marginLeft:"0px",color:"white", fontSize:"12px", fontStyle:"italic"}}>*Mapped with unofficial election results</div>
    <div className="map-geocoder-placeholder" />
  </div>
);
